import React, { Component } from "react";
import { Table } from "antd";
import { apiContract } from "../../../../../api/api-contract";
import { emitter } from "../../../../../common/utils/emitter";
import { alert } from "../../../../../common/utils/alert";
import moment from "moment";

export class EditHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataTable: [],
      total: 0,
    };

    this.table = [
      {
        title: "STT",
        dataIndex: "index",
        key: "index",
        maxWidth: 60,
      },
      {
        title: "Ngày thực hiện",
        dataIndex: "created_at",
        key: "created_at",
        render: (created_at) => (
          <div style={{ minWidth: 100 }}>
            {moment(created_at).format("DD/MM/YYYY")}
          </div>
        ),
      },
      {
        title: "Thông tin thay đổi",
        dataIndex: "field_change",
        key: "field_change",
      },
      {
        title: "Thông tin trước thay đổi",
        dataIndex: "old_value",
        key: "old_value",
      },
      {
        title: "Thông tin sau thay đổi",
        dataIndex: "new_value",
        key: "new_value",
      },
      {
        title: "Ngày hiệu lực",
        dataIndex: "effective_date",
        key: "effective_date",
        render: (created_at) => (
          <div style={{ minWidth: 100 }}>
            {moment(created_at).format("DD/MM/YYYY")}
          </div>
        ),
      },
      {
        title: "Người thực hiện",
        dataIndex: "updated_by",
        key: "updated_by",
      },
    ];
  }

  componentDidMount() {
    this.getData(1);
  }

  getData = async (page) => {
    try {
      emitter.emit("FETCH_LOADING", true);
      const result = await apiContract.getHistoryContract(
        this.props.idContract,
        page
      );
      emitter.emit("FETCH_LOADING", false);
      if (result.status === "success") {
        const dataConvert = result.data.content.map((value, index) => {
          return {
            index: index + (page - 1) * 10 + 1,
            ...value,
            data: value,
          };
        });
        this.setState({
          dataTable: dataConvert,
          total: result.data.total_elements,
        });
      } else {
        alert("error", result.data.message);
      }
    } catch (error) {
      emitter.emit("FETCH_LOADING", false);
    }
  };

  onChangePage = (page) => {
    this.getData(page);
  };

  render() {
    const { dataTable, total } = this.state;
    const { contractParam } = this.props;
    const { created_at, created_by } = contractParam;
    return (
      <div className="contract-table edit-history">
        <div className="short-info">
          <p>
            *Ngày tạo hợp đồng:{" "}
            {created_at ? moment(created_at).format("DD/MM/YYYY") : ""}
          </p>
          <p>*Người tạo hợp đồng: {created_by ? created_by.name : ""}</p>
        </div>
        <div className="edit-table-title">
          <span>Danh sách chỉnh sửa hợp đồng</span>
        </div>
        <Table
          rowKey={(record) => record.id}
          style={{ width: "100%" }}
          dataSource={dataTable}
          pagination={{ total, pageSize: 10, onChange: this.onChangePage }}
          //pagination={false}
          scroll={{ x: true }}
          columns={this.table}
        />
      </div>
    );
  }
}
